import { useRef, useState } from 'react'

export interface UseDragAndDropOptions {
  onDrop: (files: FileList) => void
}

export default function useDragAndDrop({ onDrop }: UseDragAndDropOptions) {
  const [dragging, setDragging] = useState(false)
  const dragCounter = useRef(0)

  const onDragEnter = (e: React.DragEvent<HTMLElement>) => {
    e.preventDefault()
    dragCounter.current += 1
    if (dragCounter.current === 1) {
      setDragging(true)
    }
  }

  const onDragLeave = (e: React.DragEvent<HTMLElement>) => {
    e.preventDefault()
    if (!e.currentTarget.contains(e.relatedTarget as Node)) {
      dragCounter.current = 0
      setDragging(false)
    } else {
      dragCounter.current -= 1
    }
  }

  const onDragOver = (e: React.DragEvent<HTMLElement>) => {
    e.preventDefault()
  }

  const handleDrop = (e: React.DragEvent<HTMLElement>) => {
    e.preventDefault()
    setDragging(false)
    dragCounter.current = 0

    const filesList = e.dataTransfer?.files
    if (filesList) {
      onDrop(filesList)
    }
  }

  return {
    dragging,
    eventHandlers: {
      onDragEnter,
      onDragLeave,
      onDragOver,
      onDrop: handleDrop,
    },
  }
}
